import Card from "@/components/Card";
import DashboardLayout from "@/components/layouts/Dashboard";
import {FC} from "react";
import {Construction} from "lucide-react";

interface CollaborateProps {
}

const Collaborate: FC<CollaborateProps> = () => {
  return (
    <DashboardLayout>
      <div className="max-w-7xl m-auto flex flex-col items-stretch gap-5 h-full w-full grow">
        <Card borderColor="[#dbe0f6]" bgColor="white" minHeight="full" grow stretch>
          <div className="p-5 w-full flex justify-center items-center text-2xl font-semibold text-gray-700">
            <Construction className="mx-4 mb-3 w-10 h-10"/> User Management is under maintenance
          </div>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default Collaborate;
